<p>eds-editor works!</p> 